import {
    InfiniteCalendarSeriesAction,
    InfiniteCalendarSeriesActionType,
} from '../actions/infiniteCalendarSeries';
import type { InfiniteCalendarSeriesNamespace } from '../state/infiniteCalendarSeries';
import { AccordionSection } from '../state/infiniteCalendarSeries';

export const initialState: InfiniteCalendarSeriesNamespace = {
    isTimeSectionLoading: false,
    isTicketSectionLoading: false,
    activeSection: AccordionSection.date,
    isAppRebrandActive: false,
    shouldShowTicketError: false,
    shouldShowTimeError: false,
} as InfiniteCalendarSeriesNamespace;

export const infiniteCalendarSeriesReducer = (
    state = initialState,
    action: InfiniteCalendarSeriesAction,
): InfiniteCalendarSeriesNamespace => {
    switch (action.type) {
        case InfiniteCalendarSeriesActionType.setActiveSection:
            return {
                ...state,
                activeSection: action.payload,
            };
        case InfiniteCalendarSeriesActionType.setParentEventInfo: {
            return {
                ...state,
                parentEventInfo: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setTimeSectionLoading: {
            return {
                ...state,
                isTimeSectionLoading: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setTicketSectionLoading: {
            return {
                ...state,
                isTicketSectionLoading: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setSelectedDate: {
            return {
                ...state,
                selectedDate: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setSelectedTime: {
            return {
                ...state,
                selectedTime: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setSelectedSessionId: {
            return {
                ...state,
                selectedSessionId: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setShouldShowTimeError: {
            return {
                ...state,
                shouldShowTimeError: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setShouldShowTicketError: {
            return {
                ...state,
                shouldShowTicketError: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setScrollCalendarData: {
            return {
                ...state,
                scrollCalendarData: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setCompactCalendarData: {
            return {
                ...state,
                compactCalendarData: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setCalendarType: {
            return {
                ...state,
                calendarType: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setTimeSlots: {
            return {
                ...state,
                timeSlots: action.payload,
            };
        }
        case InfiniteCalendarSeriesActionType.setCalendarDates: {
            return {
                ...state,
                calendarDates: action.payload,
            };
        }
        default:
            return state;
    }
};
